import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IAbandonedBrandCartNudgeResponse) {
    (function(BrandCartPromoState) {
        BrandCartPromoState["BRAND_CART_PROMO_STATE_UNKNOWN"] = "BRAND_CART_PROMO_STATE_UNKNOWN";
        BrandCartPromoState["NO_PROMO"] = "NO_PROMO";
        BrandCartPromoState["SINGLE_PROMO"] = "SINGLE_PROMO";
        BrandCartPromoState["MULTIPLE_PROMOS"] = "MULTIPLE_PROMOS";
    })(IAbandonedBrandCartNudgeResponse.BrandCartPromoState || (IAbandonedBrandCartNudgeResponse.BrandCartPromoState = {}));
    IAbandonedBrandCartNudgeResponse.build = function(partial) {
        return _object_spread({
            brand_cart_item_images: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IAbandonedBrandCartNudgeResponse || (IAbandonedBrandCartNudgeResponse = {}));
export var IAbandonedBrandCartNudgeResponse;
